import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import '@/assets/styles/reset.css'
import '@/assets/icons'
import '@/permission'

//Element UI
import ElementUI from 'element-ui'
ElementUI.Select.computed.readonly = function(){
  return !this.filterable;
}
import lang from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import '../static/theme/index.css'
Vue.use(ElementUI, { locale: lang })

//一些必要的配置
import '@/tool-methods'
//自定义组件
import '@/plugins'

Vue.config.productionTip = false

//赋值console对象方便输出内容
Vue.prototype.console = console;

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js